export default __webpack_public_path__ + "static/media/dummyProject.2da37733.jpeg";